export default __webpack_public_path__ + "static/media/section1-bg1-h5.7dfa2b1d.png";